import { MappingItemsSelectionNode } from './mapping-items-selection-node.interface';

export interface SuperTableMappingRowSettings {
    selectedItems: MappingItemsSelectionNode[];
    rowTitle: string | undefined;
}
